<app-header></app-header>
<app-menu></app-menu>

<div nxLayout="grid" class="nx-margin-top-2m">
    <div nxRow class="nx-margin-left-4m nx-margin-right-4m">
        <div nxCol="12,12,6,4">
            <nx-formfield label="Select Request Type">
                <nx-dropdown [(ngModel)]="requestType" (selectionChange)="changeRequestType(requestType);">
                    <nx-dropdown-item value={{policyStatus.CancelationApprovalPending}}>Cancellation Request
                    </nx-dropdown-item>
                    <nx-dropdown-item value={{policyStatus.ModificationApprovalPending}}>Modification
                        Request</nx-dropdown-item>
                </nx-dropdown>
                <nx-error nxFormfieldError>
                    Please select an option.
                </nx-error>
            </nx-formfield>
        </div>
    </div>
    <div nxRow class="nx-margin-left-4m nx-margin-right-4m">
        <div nxCol="12,12,3,2" nxAlignSelf="center">
            <nx-formfield label="Start date">
                <input nxDatefield nxInput [datepicker]="startDatepicker" [(ngModel)]="policyStartDate" />
                <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
                <nx-datepicker #startDatepicker></nx-datepicker>
                <nx-error nxFormfieldError>
                    <strong>Please note:</strong> this field is required!
                </nx-error>
            </nx-formfield>
        </div>
        <div nxCol="12,12,3,2" nxAlignSelf="center">
            <nx-formfield label="End date">
                <input nxDatefield nxInput [datepicker]="endDatepicker" [(ngModel)]="policyEndDate" />
                <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
                <nx-datepicker #endDatepicker></nx-datepicker>
                <nx-error nxFormfieldError>
                    <strong>Please note:</strong> this field is required!
                </nx-error>
            </nx-formfield>
        </div>
        <div nxCol="12,12,6,4">
            <nx-formfield>
                <input nxInput placeholder="Enter Keyword" [(ngModel)]="searchTerm" type="search">
                <span nxFormfieldPrefix>
                    <nx-icon name="search" size="s"></nx-icon>
                </span>
            </nx-formfield>
        </div>
        <div nxCol="12,12,3,2" nxAlignSelf="center">
            <button nxButton="primary small-medium" type="button"
                (click)="changeRequestType(requestType);">Search</button>
        </div>
    </div>
    <div nxRow rowJustify="start,start,around" nxRowAlignContent="end,around,stretch"
        class="nx-margin-left-4m nx-margin-right-4m" *ngIf="count!=0">
        <div nxCol="12">
            <table nxTable condensed>
                <thead>
                    <tr nxTableRow>
                        <th nxHeaderCell>
                            Policy Number
                        </th>
                        <th nxHeaderCell>
                            Vin Number
                        </th>
                        <th nxHeaderCell>
                            Customer Name
                        </th>

                        <th nxHeaderCell>
                            Policy Sale Date
                        </th>
                        <th nxHeaderCell>
                            Policy Start Date
                        </th>
                        <th nxHeaderCell>
                            Status
                        </th>
                        <th nxHeaderCell>
                            Total Amount
                        </th>
                        <th nxHeaderCell>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr nxTableRow *ngFor="let item of policyRequestList">
                        <td nxTableCell>{{item.policyNo}}</td>
                        <td nxTableCell>{{item.vinChassisNo}}</td>
                        <td nxTableCell>{{item.customerFirstName}} {{item.customerLastName}}</td>
                        <td nxTableCell>{{item.invoiceDate | date:'MM/dd/yyyy'}}</td>
                        <td nxTableCell>{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                        <td nxTableCell *ngIf="item.policyStatusId == policyStatus.CancelationApprovalPending">
                            <nx-badge type="critical" [nxTooltipPosition]="'top'"
                                [nxTooltip]="'Cancelation Approval Pending'">Pending</nx-badge>
                        </td>
                        <td nxTableCell *ngIf="item.policyStatusId == policyStatus.ModificationApprovalPending">
                            <nx-badge vibrant type="negative" [nxTooltipPosition]="'top'"
                                [nxTooltip]="'Modification Approval Pending'">Pending</nx-badge>
                        </td>
                        <td nxTableCell>{{item.price}}</td>
                        <td nxTableCell>
                            <button nxIconButton="tertiary  small" type="button" [nxTooltipPosition]="'top'"
                                [nxTooltip]="'Edit'" (click)="toggleModal(item.id,item.policyNo,item.transactionId)">
                                <nx-icon name="edit" size="s">
                                </nx-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div nxRow class="nx-margin-top-2xs nx-margin-right-5xl fright">
        <div nxCol="6">
            <nx-pagination [count]="count" [page]="pageNumber" [perPage]="pageSize" type="advanced"
                (goPrev)="prevPage()" (goNext)="nextPage()" (goPage)="goToPage($event)">
            </nx-pagination>
        </div>
    </div>
    <div nxRow>
        <div nxCol="12,10" class="nx-margin-top-2xl" *ngIf="count==0">
            <ng-container>
                <div nxRow rowJustify="center">
                    <div nxCol="12" class="nosearchresult"></div>
                    <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
                </div>
            </ng-container>
        </div>
    </div>
</div>


<app-footer></app-footer>

<nx-modal [hideOnClickOutside]="false" [hideOnEsc]="false" *ngIf="policyView" [showCloseIcon]="false">
    <div nxLayout='grid'>
        <div *ngIf="!isSuccess">
            <div nxRow nxRowJustify="start,around">
                <div nxCol="12">
                    <h1 nxHeadline="page" class="txtalign_center"> Policy Details</h1>
                </div>
            </div>
            <!-- vehicle details -->
            <div nxRow>
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Vehicle Details(Existing)</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="VIN(Chasis Number)">
                                <input nxInput value={{policyDetails.vinChassisNo}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Licence Plate NO:">
                                <input nxInput value={{policyDetails.licensePlateNo}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol='6'>
                            <nx-formfield label="Model">
                                <input nxInput value={{policyDetails.model}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Color">
                                <input nxInput value={{policyDetails.colorName}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol='6'>
                            <nx-formfield label="Vehicle Sale date">
                                <input nxInput value="{{policyDetails.vehicleSaleDate | date:'MM/dd/yyyy'}}" readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Variant">
                                <input nxInput value={{policyDetails.variant}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol='6'>
                            <nx-formfield label="Invoice Date">
                                <input nxInput value="{{policyDetails.invoiceDate | date:'MM/dd/yyyy'}}" readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Other Details">
                                <textarea nxInput value={{policyDetails.otherDetails}} readonly></textarea>
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <div nxRow *ngIf="requestType == policyStatus.ModificationApprovalPending">
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Vehicle Details(Modified)</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="VIN(Chasis Number)">
                                <input nxInput value={{policyModifiedDetails.vinChassisNo}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Licence Plate NO:">
                                <input nxInput value={{policyModifiedDetails.licensePlateNo}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol='6'>
                            <nx-formfield label="Model">
                                <input nxInput value={{policyModifiedDetails.model}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Color">
                                <input nxInput value={{policyModifiedDetails.colorName}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol='6'>
                            <nx-formfield label="Vehicle Sale date">
                                <input nxInput value="{{policyModifiedDetails.vehicleSaleDate | date:'MM/dd/yyyy'}}"
                                    readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Variant">
                                <input nxInput value={{policyDetails.variant}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol='6'>
                            <nx-formfield label="Invoice Date">
                                <input nxInput value="{{policyDetails.invoiceDate | date:'MM/dd/yyyy'}}" readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol='6'>
                            <nx-formfield label="Other Details">
                                <textarea nxInput value={{policyDetails.otherDetails}} readonly></textarea>
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <!-- PLan details -->
            <div nxRow>
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Plan Details(Existing)</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Plan Type">
                                <input nxInput value={{policyDetails.policyName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Effective Date">
                                <input nxInput value="{{policyDetails.effectiveDate |  date:'MM/dd/yyyy'}}" readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Expiry Date">
                                <input nxInput value="{{policyDetails.expiryDate |  date:'MM/dd/yyyy'}}" readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Price">
                                <input nxInput value={{policyDetails.price}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6" class="nx-margin-top-2xs">
                            <nx-formfield label="Gst Price">
                                <input nxInput value={{policyDetails.gstPrice}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <div nxRow *ngIf="requestType == policyStatus.ModificationApprovalPending">
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Plan Details(Modified)</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Plan Type">
                                <input nxInput value={{policyDetails.policyName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Effective Date">
                                <input nxInput value="{{policyModifiedDetails.effectiveDate |  date:'MM/dd/yyyy'}}"
                                    readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Expiry Date">
                                <input nxInput value="{{policyModifiedDetails.expiryDate |  date:'MM/dd/yyyy'}}"
                                    readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Price">
                                <input nxInput value={{policyDetails.price}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6" class="nx-margin-top-2xs">
                            <nx-formfield label="Gst Price">
                                <input nxInput value={{policyDetails.gstPrice}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <!-- Payment details -->
            <div nxRow>
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Payment Details</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Sold By">
                                <input nxInput value={{policyDetails.soldBy}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Payment Date">
                                <input nxInput value="{{policyDetails.paymentDate |  date:'MM/dd/yyyy'}}" readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Unit Price">
                                <input nxInput value={{policyDetails.unitPrice}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Outstanding Balance">
                                <input nxInput value={{policyDetails.outstandingBal}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <!-- Customer Details -->
            <div nxRow>
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Customer Details(Existing)</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="First Name">
                                <input nxInput value={{policyDetails.customerFirstName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Middle Name">
                                <input nxInput value={{policyDetails.customerMiddleName}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Last Name">
                                <input nxInput value={{policyDetails.customerLastName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Home Phone Number">
                                <input nxInput value={{policyDetails.customerPhoneNo}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Gst Number">
                                <input nxInput value={{policyDetails.custGstNumber}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Mobile Number">
                                <input nxInput value={{policyDetails.customerMobileNo}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Email">
                                <input nxInput value={{policyDetails.customerEmail}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Company Name">
                                <input nxInput value={{policyDetails.customerName}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="State">
                                <input nxInput value={{stateName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="City">
                                <input nxInput value={{cityName}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="PIN Code">
                                <input nxInput value={{policyDetails.pincode}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <div nxRow *ngIf="requestType == policyStatus.ModificationApprovalPending">
                <nx-card>
                    <h2 class="nx-margin-bottom-0" nxHeadline="subsection-small">Customer Details(Modified)</h2>
                    <hr>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="First Name">
                                <input nxInput value={{policyModifiedDetails.customerFirstName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Middle Name">
                                <input nxInput value={{policyModifiedDetails.customerFirstName}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Last Name">
                                <input nxInput value={{policyModifiedDetails.customerLastName}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Home Phone Number">
                                <input nxInput value={{policyModifiedDetails.customerPhoneNo}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Gst Number">
                                <input nxInput value={{policyModifiedDetails.custGstNumber}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Mobile Number">
                                <input nxInput value={{policyModifiedDetails.customerMobileNo}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="Email">
                                <input nxInput value={{policyModifiedDetails.customerEmail}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="Company Name">
                                <input nxInput value={{policyModifiedDetails.customerCompany}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="State">
                                <input nxInput value={{stateM_Name}} readonly />
                            </nx-formfield>
                        </div>
                        <div nxCol="6">
                            <nx-formfield label="City">
                                <input nxInput value={{cityM_Name}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="6">
                            <nx-formfield label="PIN Code">
                                <input nxInput value={{policyModifiedDetails.pincode}} readonly />
                            </nx-formfield>
                        </div>
                    </div>
                </nx-card>
            </div>
            <div nxRow class="nx-margin-top-2xs">
                <div nxCol="12" class="txtalign_center">
                    <button nxButton="cta primary" type="button" (click)="approveRequest()">Approve</button>
                    <button nxButton="emphasis primary" type="button" (click)="rejectRequest()">Reject</button>
                    <button nxButton="secondary" type="button" (click)="closeModal()">Close</button>
                </div>
            </div>
        </div>
        <div *ngIf="isSuccess">
            <div nxRow nxRowJustify='start,around'>
                <div nxCol="12" class="txtalign_webkitcenter">
                    <nx-spinner *ngIf="!enableClose" nxSize="large"></nx-spinner>
                    <nx-icon *ngIf="enableClose" name="check-circle" size="m" class="green"></nx-icon>
                </div>
            </div>
            <div nxRow nxRowJustify="center" class="nx-margin-top-m nx-margin-bottom-s">
                <div nxCol="12">
                    <h3 class="txtalign_center" nxHeadline="subsection-xsmall">{{successMsg}}</h3>
                </div>
            </div>
            <div class="nx-margin-top-2m" nxRow nxRowJustify="center">
                <div nxCol="12">
                    <button *ngIf="enableClose" (click)="closeModal()" nxButton="block primary">
                        close
                    </button>
                </div>
            </div>
        </div>
    </div>
</nx-modal>